import React from 'react';
import { AuthLink, useAuthContext } from './AuthContext';
import BurgerBotTemplate from './templates/BurgerBotTemplate';
import StandardTemplate from './templates/StandardTemplate';
import { ArrowLeft } from 'lucide-react';

const templates = { standard: StandardTemplate, burgerbot: BurgerBotTemplate };
export default function AuthShell({ title, children, footer, identity, variant, backTo, backLabel = 'Назад' }) {
    const { template } = useAuthContext();
    const Template = templates[template] || StandardTemplate;
    const compactBack = variant === 'registration' && backTo;
    return <div className={`auth-stage${variant === 'registration' ? ' auth-stage-registration' : ''}`}><Template>{backTo && !compactBack && <AuthLink to={backTo} className="auth-back">← {backLabel}</AuthLink>}{identity}{compactBack
        ? <div className="auth-heading-row"><AuthLink to={backTo} className="auth-back-circle" aria-label="Назад к входу" title="Назад к входу"><ArrowLeft size={18} /></AuthLink><h1 className="auth-title">{title}</h1></div>
        : <h1 className="auth-title">{title}</h1>}{children}{footer && <div className="auth-footer">{footer}</div>}</Template></div>;
}
